import React, { ReactElement, useEffect } from "react";

import { language } from "../stores/18nStore";
import CookiesSettingButton from "./CookiesSettingsPoints";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { useRef } from "react";
import ButtonOnClick from "./ButtonOnClick";

/** Cookie partners per category, kept in sync with https://sybel.co/fr/cgu/ */
const OPERATIONAL_PARTNERS = [
  { name: "Airship", url: "https://www.airship.com/legal/privacy/" },
  { name: "Stripe", url: "https://stripe.com/fr/privacy" },
  { name: "Sybel" },
  { name: "Amplitude", url: "https://amplitude.com/privacy" },
  {
    name: "Google Analytics",
    url: "https://policies.google.com/privacy?hl=fr-CA",
  },
  { name: "Twilio", url: "https://www.twilio.com/legal/privacy" },
  { name: "Recombee", url: "https://www.recombee.com/privacy-policy.html" },
  { name: "Algolia", url: "https://www.algolia.com/policies/privacy" },
  { name: "Purchasely", url: "https://www.purchasely.com/privacy-policy" },
];

const ADDS_PARTNERS = [
  { name: "Facebook", url: "https://www.facebook.com/policies/cookies/" },
  {
    name: "Instagram",
    url: "https://help.instagram.com/1896641480634370?ref=ig",
  },
  { name: "Mailchimp", url: "https://www.intuit.com/privacy/statement/" },
  { name: "Mailjet", url: "https://www.mailjet.com/legal/privacy-policy/" },
];

const SOCIAL_NETWORK_PARTNERS = [
  { name: "Facebook", url: "https://www.facebook.com/policies/cookies/" },
  {
    name: "Instagram",
    url: "https://help.instagram.com/1896641480634370?ref=ig",
  },
  {
    name: "Twitter",
    url: "https://help.twitter.com/fr/rules-and-policies/twitter-cookies",
  },
];

interface Props {
  closeCookies: (adds: boolean, socialNetworks: boolean) => void;
  setIsSocialNetwork: (value: React.SetStateAction<boolean>) => void;
  isSocialNetwork: boolean;
  setIsAdds: (value: React.SetStateAction<boolean>) => void;
  isAdds: boolean;
  setIsSettings: (value: React.SetStateAction<boolean>) => void;
  setIsMoreInformations: (value: React.SetStateAction<boolean>) => void;
  isMoreInformations: boolean;
}

export default function CookiesSettings({
  closeCookies,
  setIsSocialNetwork,
  isSocialNetwork,
  setIsAdds,
  isAdds,
  setIsSettings,
  setIsMoreInformations,
  isMoreInformations,
}: Props): ReactElement {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const thisRef = ref && ref.current;
    thisRef && disableBodyScroll(thisRef);
    return () => (thisRef ? enableBodyScroll(thisRef) : undefined);
  }, []);
  return (
    <>
      <div className="cookies-main-title">
      <ButtonOnClick
              cta="cookiesDisableAll"
              onClick={() => {
                setIsSocialNetwork(false);
                setIsAdds(false);
                return closeCookies(false, false);
              }}
              customClassName="denied-btn-web"
            />
      <ButtonOnClick
          cta="cookiesDisableAll"
          onClick={() => {
            setIsSocialNetwork(false);
            setIsAdds(false);
            return closeCookies(false, false);
          }}
          customClassName="denied-btn-mobile"
        />
        <img
          onClick={() => {
            setIsAdds(true);
            setIsSocialNetwork(true);
            return setIsSettings(false);
          }}
          src="/image/pop-up-back.svg"
          alt=""
        />
        <h3>{language("cookiesSettingsTitle")}</h3>
      </div>
      <div ref={ref} className="cookies-main-part">
        <div className="cookies-main-part-container">
          <div className="cookies-setting-subtitle">
            <p>{language("cookiesSettingsSubTitle")}</p>
          </div>
          <CookiesSettingButton
            title="cookiesSettingsTitleCantDisable"
            paragraph="cookiesSettingsTitleCantDisableParagraph"
            disabled={true}
            state={true}
            partners={OPERATIONAL_PARTNERS}
          />
          <div
            className="cookies-setting-more-informations"
            onClick={() => setIsMoreInformations(!isMoreInformations)}
          >
            <p>{language("cookiesSettingsTitleCantDisableMoreInformations")}</p>
            <img
              style={{
                transform: isMoreInformations
                  ? "rotate(90deg)"
                  : "rotate(0deg)",
              }}
              src="/image/cookies-arrow.svg"
              alt=""
            />
          </div>
          {isMoreInformations && (
            <div
              className="cookies-setting-more-informations-details"
              onClick={() => setIsMoreInformations(!isMoreInformations)}
            >
              <p className="cookies-setting-subtitle-button">
                {language(
                  "cookiesSettingsTitleCantDisableMoreInformationsListTitle"
                )}
              </p>
              <ul>
                {Array.from(Array(5), (e, i) => {
                  return (
                    <li key={i}>
                      {language(
                        `cookiesSettingsTitleCantDisableMoreInformationsList${
                          i + 1
                        }`
                      )}
                    </li>
                  );
                })}
              </ul>
              <p className="cookies-setting-subtitle-button">
                {language(
                  "cookiesSettingsTitleCantDisableMoreInformationsListFooter"
                )}
              </p>
            </div>
          )}
          <CookiesSettingButton
            title="cookiesAddsTitle"
            paragraph="cookiesAddsParagraphe"
            setStates={setIsAdds}
            state={isAdds}
            partners={ADDS_PARTNERS}
          />
          <CookiesSettingButton
            title="cookiesSocialNetworkTitle"
            paragraph="cookiesSocialNetworkParagraphe"
            setStates={setIsSocialNetwork}
            state={isSocialNetwork}
            partners={SOCIAL_NETWORK_PARTNERS}
          />
        </div>
      </div>
      <div className="cookies-save-changes">
        <ButtonOnClick
          cta="cookiesSettingsValidation"
          onClick={() => closeCookies(isAdds, isSocialNetwork)}
          noClassName
        />
      </div>
    </>
  );
}
